import { useNavigate } from 'react-router-dom';

import Checkbox from '@lib/core/src/components/Checkbox';

import { CalendarMeetingInfoDto } from '@/api/generated';
import { onMeetingClick } from '@/components/MeetingHub/utils/util';
import { useSelectedMeetingsActions, useIsMeetingSelected } from '@/store/selectedMeetingsStore';
import { stringToTime } from '@/utils/dateUtil';

import {
  Container,
  ImageContainer,
  TextContainer,
  Title,
  SubTitle,
  Image,
  ArrowRightIcon
} from './MeetingsRowStyles';

interface MeetingRowProps {
  meeting: CalendarMeetingInfoDto;
}

const MeetingRow = ({ meeting }: MeetingRowProps) => {
  const { addRemoveSelectedMeeting } = useSelectedMeetingsActions();
  const isMeetingSelected = useIsMeetingSelected(meeting.id ?? '');

  const handleCheckboxClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    addRemoveSelectedMeeting(meeting);
  };

  const navigate = useNavigate();

  const handleMeetingClick = (meeting: CalendarMeetingInfoDto) => {
    onMeetingClick(meeting, navigate);
  };

  return (
    <Container onClick={() => handleMeetingClick(meeting)}>
      <ImageContainer>
        <Checkbox checked={isMeetingSelected} onClick={handleCheckboxClick} />
        <Image imageUrl={`data:image/jpg;base64,${meeting.thumbnail}`} />
      </ImageContainer>
      <TextContainer>
        <Title variant="h6">{meeting.title}</Title>
        <SubTitle>{stringToTime(meeting.startTime, true)}</SubTitle>
      </TextContainer>
      <ArrowRightIcon className="arrow-right-icon" />
    </Container>
  );
};

export default MeetingRow;
